import { ScanSearch } from 'lucide-react';

export default function Brand({ compact = false }) {
  return (
    <div className={`brand ${compact ? 'brand-compact' : ''}`}>
      <span className="brand-symbol"><ScanSearch size={compact ? 20 : 24} /></span>
      <span className="brand-copy"><strong>Scan &amp; View</strong><small>MENU</small></span>
    </div>
  );
}
